"use client";
import React from 'react';
import { extractDigits, formatPhone, maskPhone } from '../../lib/phoneMask';

const PREFIX = '+7 (';

const PhoneInput = ({ value, onChange, onFocus, onBlur, placeholder = '+7 (___) ___-____', ...rest }) => {
  const handleChange = (e) => onChange(maskPhone(e.target.value));

  // Backspace на символе маски ("-", ")", " ") удаляет предыдущую цифру, иначе курсор застревает
  const handleKeyDown = (e) => {
    if (e.key !== 'Backspace') return;
    const { selectionStart, selectionEnd } = e.target;
    if (selectionStart !== selectionEnd || selectionStart <= PREFIX.length) return;
    if (/\d/.test(value[selectionStart - 1])) return;

    e.preventDefault();
    const digitsBefore = value.slice(0, selectionStart).replace(/\D/g, '').length;
    const digits = value.replace(/\D/g, '');
    if (digitsBefore <= 1) return;
    onChange(formatPhone(digits.slice(0, digitsBefore - 1) + digits.slice(digitsBefore)));
  };

  // Вставка полного номера (+7..., 8..., 9...) заменяет значение целиком
  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData('text');
    const pastedDigits = pasted.replace(/\D/g, '');
    if (pastedDigits.length < 10) return;
    e.preventDefault();
    onChange(formatPhone(extractDigits(pastedDigits)));
  };

  const handleFocus = (e) => {
    if (!value) onChange(PREFIX);
    onFocus?.(e);
  };

  const handleBlur = (e) => {
    if (value === PREFIX) onChange('');
    onBlur?.(e);
  };

  return (
    <input
      type="tel"
      inputMode="tel"
      autoComplete="tel"
      placeholder={placeholder}
      value={value}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
      onPaste={handlePaste}
      onFocus={handleFocus}
      onBlur={handleBlur}
      {...rest}
    />
  );
};

export default PhoneInput;
